<template>
  <form @keyup.esc="close()" tabindex="0" >
  <v-layout id='calender_iframe_view' class='modif-iframe-view' v-resize="onResize" v-if="mapData.iframeView.show" :style="{'left': left, 'top': top}">
    <v-layout class="modif-view-wrap" column>
      <v-layout class="view-title-bar" v-on:mousedown="dragStart" align-center justify-space-between row shrink>
        <v-flex class="text-xs-left hidden-md-and-up" shrink>
          <v-btn fit icon @click="close()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
        </v-flex>
        <v-flex :class="['text-xs-left', 'title-text', ($vuetify.breakpoint.mdAndUp) ? 'pl-4' : 'pl-1']">
          <!--{{mapData.iframeView.title}}-->
          일정/상담 관리
        </v-flex>
        <v-flex class="text-xs-right hidden-sm-and-down mr-1" shrink>
          <v-btn fit icon @click="close()"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-layout>
      <v-flex>
        <v-tabs fixed-tabs grow v-model="mapData.iframeView.tab" style="border-bottom: solid 1px #d5d5d5;">
          <v-tabs-slider color="title_color" grow></v-tabs-slider>
          <v-tab key="1" href="#iframeview-tab-1" >
            캘린더
          </v-tab>
          <v-tab key="1" href="#iframeview-tab-2" >
            방찾아주세요
          </v-tab>
          <v-tab key="1" href="#iframeview-tab-3" >
            방내놔요
          </v-tab>
        </v-tabs>
      </v-flex>
      <!--
      <v-flex class="view-iframe view-full-height" glow xs12>
        <iframe :src="mapData.iframeView.src" style="width: 100%; height: 100%;" frameborder="0" id="modif_iframe"></iframe>
      </v-flex>
      -->
      <v-flex class="view-iframe iframeview-modal-tab" glow xs12>
        <v-tabs-items v-model="mapData.iframeView.tab" class="fill-height">
          <v-tab-item
            key="1"
            value="iframeview-tab-1"
          >
            <v-flex class="view-iframe view-full-height" glow xs12>
              <iframe :src="$utile.getBaseUrl() + '/bbs/board?bo_table=pro_calendar&hl=2'" style="width: 100%; height: 100%;" frameborder="0" id="modif_iframe"></iframe>
            </v-flex>
          </v-tab-item>
          <v-tab-item
            key="2"
            value="iframeview-tab-2"
          >
            <v-flex class="view-iframe view-full-height" glow xs12>
              <iframe :src="$utile.getBaseUrl() + '/bbs/board?bo_table=rep_item_request&hl=2'" style="width: 100%; height: 100%;" frameborder="0" id="modif_iframe"></iframe>
            </v-flex>
          </v-tab-item>
          <v-tab-item
            key="3"
            value="iframeview-tab-3"
          >
            <v-flex class="view-iframe view-full-height" glow xs12>
              <iframe :src="$utile.getBaseUrl() + '/bbs/board?bo_table=rep_item_receipt2&hl=2'" style="width: 100%; height: 100%;" frameborder="0" id="modif_iframe"></iframe>
            </v-flex>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
      <!--
      <v-flex class="view-bottom-bar" shrink xs12>
        <v-btn depressed color="error" @click="delAction()" v-if="mapData.modifView.btDel">삭제</v-btn><v-btn depressed color="primary" @click="submitAction()" v-if="mapData.modifView.btUpdate">등록</v-btn>
      </v-flex>
      -->
    </v-layout>
  </v-layout>
  </form>
</template>

<script>
import Utile from '@/utile/utile'
import EventBus from '@/utile/eventBus'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'IFrameView',
  data: () => ({
    // 뷰
    drag: false,
    viewElement: null,
    currentX: 0,
    currentY: 0,
    initialX: 0,
    initialY: 0,
    xOffset: 0,
    yOffset: 0,
    top: 0,
    left: 0,
    isMobile: Utile.isMobile()
  }),
  components: {
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      auth: state => state.auth
    })
  },
  mounted () {
    // 메세지 청취
    window.addEventListener('message', (e) => {
      let msg = e.data
      if (msg !== undefined && msg.constructor === String) {
        // console.log('13:', msg)
        if (msg.startsWith('@title:')) {
          this.mapData.modifView.title = msg.replace('@title:', '')
        } else if (msg.startsWith('@showBtDel')) {
          this.mapData.modifView.btDel = true
        } else if (msg.startsWith('@showBtUpdate')) {
          this.mapData.modifView.btUpdate = true
        } else if (msg.startsWith('@hideBtDel')) {
          this.mapData.modifView.btDel = false
        } else if (msg.startsWith('@hideBtUpdate')) {
          this.mapData.modifView.btUpdate = false
        } else if (msg.startsWith('@reload')) {
          // EventBus.$emit('reloadDetail')
        } else if (msg.startsWith('@refresh')) {
          EventBus.$emit('reloadDetail')
          this.mapData.modifView.show = false
        } else if (msg.startsWith('@link:')) {
          //
        }
      }
    }, false)
  },
  methods: {
    ...mapActions({
      requestMapData: 'mapData/requestMapData'
    }),
    submitAction () {
      document.getElementById('modif_iframe').contentWindow.postMessage('@submitAction', '*')
    },
    delAction () {
      document.getElementById('modif_iframe').contentWindow.postMessage('@delAction', '*')
    },
    getStaticUrl () {
      return Utile.getStaticUrl()
    },
    close () {
      this.mapData.iframeView.show = false
      this.mapData.iframeView.title = ''
      this.mapData.iframeView.btUpdate = false
      this.mapData.iframeView.btDel = false
    },
    dragStart (e) {
      if (!Utile.isMobile()) {
        this.drag = true
        this.viewElement = document.getElementById('calender_iframe_view')
        this.initialX = e.clientX - this.xOffset
        this.initialY = e.clientY - this.yOffset
        window.addEventListener('mousemove', this.dragging, false)
        window.addEventListener('mouseup', this.dragEnd, false)
      }
    },
    dragEnd (e) {
      if (!Utile.isMobile()) {
        this.drag = false
        window.removeEventListener('mousemove', this.dragging, false)
        window.removeEventListener('mouseup', this.dragEnd, false)
      }
    },
    dragging (e) {
      if (this.drag) {
        this.currentX = e.clientX - this.initialX
        this.currentY = e.clientY - this.initialY

        this.xOffset = this.currentX
        this.yOffset = this.currentY
        // this.viewElement.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`
        this.top = this.currentY + 'px'
        this.left = this.currentX + 'px'
      }
    },
    onResize () {
      if (document.getElementById('calender_iframe_view') != null) {
        if (this.top === 0) {
          let top = (window.innerHeight / 2) - (document.getElementById('calender_iframe_view').clientHeight / 2)
          let left = (window.innerWidth / 2)
          this.top = top + 'px'
          this.left = left + 'px'
          this.xOffset = left
          this.yOffset = top
        }
      }
    }
  }
}
</script>

<style scoped>
  .v-window__container { height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/modal/IFrameView.vue